/*
 * @Author: Liux
 * @Date: 2020-01-02 05:53:25
 * @LastEditor: Liux
 * @LastEditTime : 2020-01-02 07:28:29
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdAlertComponent } from './ad-alert.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { AdAlertService } from './ad-alert.service';
import { AdButtonModule } from '../ad-button/ad-button.module';

@NgModule({
  declarations: [AdAlertComponent],
  imports: [
    CommonModule,
    OverlayModule,
    PortalModule,
    AdButtonModule
  ],
  exports: [AdAlertComponent],
  providers: [AdAlertService],
  //entryComponents: [AdAlertComponent]
})
export class AdAlertModule {}
export * from './common/ad-alert-config';
export { AdAlertService };
